import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    leftContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    rightContent: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
    },
}));
